// Horizontal Linear Stapper
import React, { Fragment, PureComponent } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';

import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import Selectsearch from "react-select"
import moment from 'moment';
// import DateFnsUtils from '@date-io/date-fns';
// import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'; // Or AdapterMoment, AdapterDayjs, etc.


import {
	FormGroup,
	Label,
} from 'reactstrap';

// rct card box
import { RctCardContent } from 'Components/RctCard';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

import {
    allStudents,
    allAcademys,
    addAcademyAdmin,
    assignAcademyAdmin,
    getParticularAcademyProgram,
    assignProgramForStudent
} from 'Actions';

function getSteps() {
   return ['Create or Select Student', 'Assign Academy', 'Assign Program'];
}


class StudentWorkflow extends React.Component {
   static propTypes = {
      classes: PropTypes.object,
   };

   UNSAFE_componentWillMount() {
         this.props.allStudents();
         this.props.allAcademys(); 
         this.props.getParticularAcademyProgram();
         const role = localStorage.getItem('user_role');
         const usracademy = localStorage.getItem('user_academy');
         if (role == 2) {
            this.setState({ academy: usracademy });
         }
         
	}

   state = {
      activeStep: 0,
      skipped: new Set(),
      academy:"",
      program:"",
      selstudent:"",
      selectedDate: moment(),
      lstaction:0,
      selprogram:[],
   };
   isStepOptional = step => {
      return step === 1;
   };
   isStepSkipped(step) {
      return this.state.skipped.has(step);
   }
   handleNext = () => {
      const { activeStep } = this.state;
      let { skipped } = this.state;
      let { lstaction } = this.state;
      let { selstudent } = this.state;
      let { academy } = this.state;
      let {program} = this.state;
      if(activeStep==0){
          if(lstaction==0 && selstudent==""){
            alert('Please select the student or create student');   
          }else{            
            this.setState({
                activeStep: 1,
            });
          }   
      }else if(activeStep==1){ 
            if(academy==""){
               alert('Please select the academy');  
            }else{
               this.props.assignAcademyAdmin(academy,selstudent,6).then((data) => {   
                  this.props.getParticularAcademyProgram(this.state.academy);      
                  if(data.status==1){
                     this.setState({
                        activeStep: 2,
                     });
                     
                  }
               });
            }  
      }
      
      else if (activeStep === 2) {
         if (program === "") {
            alert('Please select the program');
         } else {
            this.props.assignProgramForStudent(this.state.selstudent, this.state.program).then((data) => {
               if (data.status === 1) {
                  this.setState({
                     activeStep: activeStep + 1,
                  });
               }
            });
         }
      }
      
      else{
        
         if(this.isStepSkipped(activeStep)) {
            skipped = new Set(skipped.values());
            skipped.delete(activeStep);
         }
         this.setState({
            activeStep: activeStep + 1,
            skipped,
         });
      }
   };

    multiSelectChange = (e) => {
        this.setState({selstudent: e.value});
    }

    handleChange = (e) => {
        let tstchk=e.target.checked;
        let optval=e.target.value;
        
        if(tstchk==true){
            this.setState({
                selprogram:[...this.state.selprogram, optval]
              });
        }else{
            let filteredArray = this.state.selprogram.filter(item => item !== optval)
            this.setState({selprogram: filteredArray});
        }        
    }

   handleBack = () => {
      const { activeStep } = this.state;
      this.setState({
         activeStep: activeStep - 1,
      });
   };

   handleDateChange = (e) => {
       
       let seldate=e;
       this.setState({selectedDate: e});
   }
  
   addHandleSubmit(event){
      event.preventDefault();
      const role = localStorage.getItem('user_role');
      this.props.addAcademyAdmin(event,this.state.academy,this.state.selectedDate,4).then((data) => {         
         if(data.status==1){
            const adstud=data.data;
            if(role==2){
               this.setState({
                  selstudent: adstud, 
                  lstaction:1,
                  activeStep:2,
               });
            }else{
               this.setState({
                  selstudent: adstud, 
                  lstaction:1,
                  activeStep:1,
               });
            }
            document.getElementById("membersform").reset(); 
         }
      });
      
   }

   
   selAcademy = (evt) => {
      const academyid = evt.target.value;
      this.setState({ academy: academyid });
   }

   selProgram = (evt) => {
      const programid = evt.target.value;
      this.setState({ program: programid });
   }

   render() {
      const steps = getSteps();
      const { activeStep } = this.state;
      const { studentlists, academylists,assignedstudents, loading } = this.props;
     
      const allstudent=studentlists.map((stdval) => {  
        return {
        label: stdval.student,  
        value: stdval.uudID
        }
      });

      
      return (
         <div className="hoz-linear-stepper">
            <Stepper alternativeLabel nonLinear activeStep={activeStep}>
               {steps.map((label, index) => {
                  const props = {};
                  const labelProps = {};
                  if (this.isStepOptional(index)) {
                     labelProps.optional = '';
                  }
                  if (this.isStepSkipped(index)) {
                     props.completed = false;
                  }
                  return (
                     <Step key={label} {...props}>
                        <StepLabel {...labelProps}>{label}</StepLabel>
                     </Step>
                  );
               })}
            </Stepper>
            <div className="pl-40">
                 
                  {(function(){
                  if (activeStep === 0) {

                  //{activeStep === 0 ? (
                     return <div>

                         <div className="row">
                           <div className="col-md-12">
                                <div className="col-md-8" style={{margin:"0 auto"}}>                                    
                                    <div className="col-md-12">
                                        <RctCollapsibleCard>
                                        <FormControl fullWidth>
                                            <FormGroup>
                                                <Label for="Select">Select Students</Label>
                                                <Selectsearch className="form-control h-auto w-100" id="student" name="student" options={allstudent} value={allstudent.find(obj => obj.value === this.state.selstudent)} onChange={this.multiSelectChange} required/>
                                             </FormGroup>
                                        </FormControl>
                                        </RctCollapsibleCard>
                                    </div>
                                    <div className="col-md-12 text-center"> (OR) </div>
                                    <div className="col-md-12">
                                        <RctCollapsibleCard>
                                        <form autoComplete="off"  id="membersform" onSubmit={(e)=>this.addHandleSubmit(e)}>
                                            <h4>Add Student</h4>
                                            <div className="form-group">
                                            <TextField  required id="fname" name="fname" fullWidth label="First Name" />
                                            </div>
                                            <div className="form-group">
                                            <TextField required id="lname" name="lname" fullWidth label="Last Name" />
                                            </div>
                                            <div className="form-group">
                                            <TextField type="email" required id="email" autoComplete="new-email" name="email" fullWidth label="Email" />    
                                            </div>
                                            <div className="form-group">
                                            <TextField  type="phone" required id="mobile" name="mobile" fullWidth label="Mobile" />
                                            </div>
                                            <div className="form-group">
                                            
                                            <Fragment>
                                                <div className="rct-picker">
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            label="Date of Birth"
            value={this.state.selectedDate}
            onChange={this.handleDateChange}
            inputFormat="yyyy-MM-dd"
            components={{
              LeftArrowIcon: () => <i className="zmdi zmdi-arrow-back" />,
              RightArrowIcon: () => <i className="zmdi zmdi-arrow-forward" />,
            }}
            renderInput={(params) => <TextField {...params} fullWidth margin="normal" />}
          />
        </LocalizationProvider>
      </div>
                                            </Fragment>
                                        
                                            </div>
                                            
                                            <FormControl fullWidth>
                                                <InputLabel htmlFor="age-simple">Gender</InputLabel>
                                                <Select inputProps={{ name: 'gender', id: 'gender', }} required >
                                                   <MenuItem value=""><em>None</em></MenuItem>
                                                   <MenuItem value="1"><em>Male</em></MenuItem>
                                                   <MenuItem value="2"><em>Female</em></MenuItem>                                   
                                                </Select>
                                             </FormControl>  
                                       
                                            <div className="form-group">
                                            <TextField type="password" required id="password" name="password" autoComplete="new-password" fullWidth label="Password" />
                                            </div>
                                            <div className="form-group">
                                            <input type="submit" className="mr-3 mb-3 btn btn-outline-primary" value="Submit" />
                                            </div>
                                        </form>  
                                        </RctCollapsibleCard> 
                                    </div>
                                </div>
                            </div>
                           
                              <Button onClick={this.props.onClick} className="btn-danger text-white mr-3 mb-3" >
                                 Back
                              </Button>
                              <Button variant="contained" onClick={this.handleNext} color="primary" className="text-white mr-3 mb-3">
                                 {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                              </Button>
                           
                        </div>   
                     </div>  
                   } else if (activeStep === 1) {    
                  //) : (
                     return <div>
                        <div className="row">
                            <div className="col-md-12 col-xs-12 col-lg-12">
                                <h4>Assign Academy</h4>
                                <div className="form-group col-md-6">
                                    <FormControl fullWidth>
                                       <InputLabel htmlFor="age-simple">Select Academy</InputLabel>
                                       <Select value={this.state.academy} onChange={this.selAcademy}
                                          inputProps={{ name: 'academy', }}>
                                          <MenuItem value=""><em>None</em></MenuItem>
                                          {academylists.map((acdylst) => (
                                             <MenuItem value={acdylst.aadID}>{acdylst.aad_name}</MenuItem>
                                          ))}
                                       </Select>
                                    </FormControl>
                                 </div>

                                    
                            </div>
                          
                           <Button disabled={activeStep === 0} onClick={this.handleBack} className="btn-danger text-white mr-3 mb-3" >
                              Back
                           </Button>
                           <Button variant="contained" onClick={this.handleNext} color="primary" className="text-white mr-3 mb-3">
                              {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                           </Button>
                        </div>   
                     </div>

                   }else if (activeStep === 2) {
                     return (
                        <div>
                               <div className="row">
                            <div className="col-md-12 col-xs-12 col-lg-12">
                                <h4>Assign Program</h4>
                                <div className="form-group col-md-6">
                                    <FormControl fullWidth>
                                       <InputLabel htmlFor="age-simple">Select Program</InputLabel>
                                       <Select value={this.state.program} onChange={this.selProgram}
                                          inputProps={{ name: 'program', }}>
                                          <MenuItem value=""><em>None</em></MenuItem>
                                          {assignedstudents.map((pgmlst) => (
                                             <MenuItem value={pgmlst.aapID}>{pgmlst.aap_name}</MenuItem>
                                          ))}
                                       </Select>                                     
                                    </FormControl>
                                 </div>

                                    
                            </div>
                          
                           <Button disabled={activeStep === 0} onClick={this.handleBack} className="btn-danger text-white mr-3 mb-3" >
                              Back
                           </Button>
                           <Button variant="contained" onClick={this.handleNext} color="primary" className="text-white mr-3 mb-3">
                              {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                           </Button>
                        </div>   
                        </div>
                     );
                  }else{
                     return <div>
                           <div className="row">
                              <div className="col-md-12">
                                 <div className="alert bg-success text-white col-sm-12 col-md-6 col-lg-6" role="alert">
                                    <strong>Well done!</strong> You successfully assign student academy.
                                 </div>
                              </div>
                              <Button onClick={this.props.onClick} className="btn-danger text-white mr-3 mb-3" >
                                 Back to Home
                              </Button>
                           </div>
                     </div>
                   }  
                  }).call(this)} 
                  
            </div>
         </div>
      );
   }
}

const mapStateToProps = ({mostlyused, academy, workflow }) => {
   const { studentlists, loading } = mostlyused;
   const { academylists} = academy;
   const { assignedstudents } = workflow;
	return { studentlists, academylists, assignedstudents,loading };
}

export default connect(mapStateToProps, {
    allStudents,
    addAcademyAdmin,
    allAcademys,
    assignAcademyAdmin,
    getParticularAcademyProgram,
    assignProgramForStudent
})(StudentWorkflow); 
